<template>
    <div class="nomore">
        <img src="../../assets/static/index/nomore.png" alt="">
    </div>
</template>

<script>
    export default {
        
    }
</script>

<style lang="scss" scoped>
.nomore {
    width: 100%;
    height: 100%;
    padding-top: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
}
</style>